// MonitoringTypesが増えた場合はenumを追加し、Signal*MonitoringTypesの追加したタイプのordinal値として使用すること
export enum SignalMonitoringTypes {
  BrandShareRate = 0,
  BrandSalesAmount = 1,
  BrandSalesQuantity = 2,
  BrandSalesRate = 3,
  CategoryTrendingItemQuantity = 4,
  CategoryPlummetingItemQuantity = 5,
};

export const NotificationSignalTypes = {
  ShareRate: { ordinal: SignalMonitoringTypes.BrandShareRate, label: "金額シェア（ブランド）" },
  SalesAmount: { ordinal: SignalMonitoringTypes.BrandSalesAmount, label: "売上金額（ブランド）" },
  SalesQuantity: { ordinal: SignalMonitoringTypes.BrandSalesQuantity, label: "売上個数（ブランド）" },
  SalesRate: { ordinal: SignalMonitoringTypes.BrandSalesRate, label: "購入率（ブランド）" },
};

export const DetectionSignalTypes = {
  TrendingItemQuantity: { ordinal: SignalMonitoringTypes.CategoryTrendingItemQuantity, label: "急伸商品検知（個数）" },
  PlummetingItemQuantity: { ordinal: SignalMonitoringTypes.CategoryPlummetingItemQuantity, label: "急落商品検知（個数）" },
};

export const SignalCategories = {
  notification: { label: "通知系", types: NotificationSignalTypes },
  detection: { label: "検知系", types: DetectionSignalTypes },
};

export const SignalSalesAmountResultType = {
  salesAmount: "sales_amount",
  salesQuantity: "sales_quantity",
};

export const SignalThresholdLevels = [
  { id: 0, label: "高" },
  { id: 1, label: "中" },
  { id: 2, label: "低" },
];

export const SignalNoticeTypes = [
  { id: 0, label: "毎日" },
  { id: 1, label: "超過日のみ" },
];

export const SignalMonitoringRecipientTypes = {
  groupMember: 0,
  userTeam: 1,
} as const;

export const SignalGroupMemberTypes = {
  editor: { ordinal: 0, label: "編集者" },
  viewer: { ordinal: 1, label: "閲覧者" },
} as const;
